// extracted by mini-css-extract-plugin
export default {"list":"List_list__n6VRC","filterWrapper":"List_filterWrapper__WNp8U","tableWrapper":"List_tableWrapper__1k0mg"};